import React, { useContext, useEffect, useRef, useState } from 'react';
import AuthContext from '../../contexts/AuthContext';
import '../../index.css';
import {
  getUserDetail,
  getTelecomList,
  getIndustryList,
  updateUser,
} from '../../modules/NetworkFunction';
import Title from '../../components/Title';
import styled from 'styled-components';

function MyPageMemberInfo() {
  const { auth: token } = useContext(AuthContext);
  const phoneRegex = /^[0-9]{11}$/;

  const [isLoaded, setIsLoaded] = useState(false);
  const [telecomList, setTelecomList] = useState([]);
  const [isTelecomListLoaded, setIsTelecomListLoaded] = useState(false);
  const [data, setData] = useState(null); // user 정보 데이터

  const [check, setCheck] = useState({
    phoneCheck: true, //폰 번호 3개 모두 조건 맞아야함
    companyCheck: true,
    industryCheck: true,
    nameCheck: true, // 이것들 + sTerm 체크할것
  });
  const [nextBtnDisabled, setNextBtnDisabled] = useState(false);
  const [isPhoneChange, setIsPhoneChange] = useState(false);

  const phoneRef = useRef(null);

  useEffect(() => {
    let v =
      check.companyCheck &&
      check.phoneCheck &&
      check.industryCheck &&
      check.nameCheck;

    setNextBtnDisabled(!v);
  }, [check, nextBtnDisabled]);

  const onChange = (e) => {
    const { value, name } = e.target;
    setData({ ...data, [name]: value });

    if (name === 'company' && value === '') {
      setCheck({ ...check, companyCheck: false });
    } else if (name === 'company' && value !== '') {
      setCheck({ ...check, companyCheck: true });
    }
    if (name === 'userName' && value === '') {
      setCheck({ ...check, nameCheck: false });
    } else if (name === 'userName' && value !== '') {
      setCheck({ ...check, nameCheck: true });
    }
  };

  useEffect(() => {
    if (!isLoaded) {
      getUserDetail(
        null,
        (v) => {
          setData(v.user);
        },
        setIsLoaded,
        (e) => {
          console.log('getuserdetail', e);
        },
        token
      );
    }
  }, [check, data, isLoaded]);

  useEffect(() => {
    if (!isTelecomListLoaded) {
      getTelecomList(null, setTelecomList, setIsTelecomListLoaded, (v) => {
        if (v) console.log('getTelecomList Error');
      });
    }
  }, [isTelecomListLoaded, telecomList, data]);

  const [industryList, setIndustryList] = useState([]);
  const [isIndustryListLoaded, setIsIndustryListLoaded] = useState(false);

  useEffect(() => {
    if (!isIndustryListLoaded) {
      getIndustryList(
        null,
        (e) => {
          setIndustryList([
            ...e,
            { industryName: '패션', industryNo: 4 },
            { industryName: '뷰티', industryNo: 5 },
            { industryName: '푸드', industryNo: 6 },
            { industryName: '가구/인테리어', industryNo: 7 },
            { industryName: '엔터테인먼트', industryNo: 8 },
            { industryName: '여행/숙박', industryNo: 9 },
          ]);
        },
        setIsIndustryListLoaded,
        (v) => {
          if (v) console.log('getIndustryList Error');
        }
      );
    }
    console.log(data);
  }, [isIndustryListLoaded]);

  return (
    <div>
      <Title title="회원정보" />
      <div style={{ marginBottom: 20, color: '#848484' }}>
        <p style={{ fontSize: 18 }}>이메일</p>
        <p style={{ fontSize: 16 }}>{data == null ? '' : data.userMail}</p>
      </div>

      <div>
        <p style={{ fontSize: 18 }}>휴대폰 번호*</p>
        <div className="input-box">
          <select
            name="telecomNo"
            onChange={onChange}
            value={data == null ? '' : data.telecomNo}
            style={{
              width: 89,
              height: 38,
              marginRight: 13,
              cursor: 'pointer',
            }}
          >
            {telecomList.map(function (n) {
              return (
                <option key={n.telecomName} value={n.telecomNo}>
                  {n.telecomName}
                </option>
              );
            })}
          </select>
          <input
            type="text"
            name="userPhone"
            ref={phoneRef}
            style={{ width: 150, height: 38, marginRight: 10 }}
            value={data == null ? '' : data.userPhone}
            onChange={(e) => {
              onChange(e);
              setIsPhoneChange(true);
              let v = phoneRegex.test(e.target.value);
              setCheck({ ...check, phoneCheck: v });
            }}
          />
          <p
            style={{
              color: '#FF8A00',
              display: isPhoneChange ? 'block' : 'none',
            }}
          >
            {check.phoneCheck
              ? '휴대폰 번호가 확인되었습니다.'
              : '휴대폰 번호는 11자리를 입력해야합니다.'}
          </p>
        </div>
      </div>

      <div>
        <p style={{ fontSize: 18 }}>회사명*</p>
        <div className="input-box">
          <input
            type="text"
            name="company"
            value={data == null ? '' : data.company}
            onChange={onChange}
            style={{ width: 295, height: 38 }}
          />
          <p style={{ color: '#FF8A00', marginLeft: '1rem' }}>
            {check.companyCheck ? '' : '회사명은 필수로 입력해야 합니다.'}
          </p>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div>
          <p style={{ fontSize: 18 }}>업종*</p>
          <div className="input-box">
            <select
              onChange={onChange}
              value={data == null ? '' : data.industry}
              name="industry"
              style={{
                width: 152,
                height: 38,
                marginRight: 13,
                cursor: 'pointer',
              }}
            >
              {industryList.map(function (n) {
                return (
                  <option key={n.industryName} value={n.industryName}>
                    {n.industryName}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div>
          <p style={{ fontSize: 18 }}>상세 업종</p>
          <div className="input-box">
            <input
              type="text"
              name="industryDetail"
              value={data == null ? '' : data.industryDetail}
              style={{ width: 295, height: 38 }}
              onChange={onChange}
              placeholder={'ex) 의류, 잡화편집샵, 스포츠용품 등'}
            />
          </div>
        </div>
      </div>
      <div>
        <p style={{ fontSize: 18 }}>담당자명*</p>
        <div className="input-box">
          <input
            type="text"
            name="userName"
            value={data == null ? '' : data.userName}
            onChange={onChange}
            style={{ width: 188, height: 38 }}
          />
          <p style={{ color: '#FF8A00', marginLeft: '1rem' }}>
            {check.nameCheck ? '' : '담당자명은 필수로 입력해야 합니다.'}
          </p>
        </div>
      </div>

      <div style={{ height: 30 }}></div>
      <div>
        <Title title="약관동의" />

        <div className="checkbox-list">
          <input
            type="checkbox"
            id="marketingTerm"
            name="marketingTerm"
            checked={data === null ? false : data.marketingTerm}
            onChange={() =>
              setData({ ...data, marketingTerm: data.marketingTerm ? 0 : 1 })
            }
          />
          <label htmlFor="marketingTerm">
            <span>마케팅 정보 수신에 동의합니다. (선택)</span>
          </label>
        </div>
      </div>
      <ButtonContainer>
        <RoundButton
          backgroundColor={nextBtnDisabled ? '#CCC' : '#FFB600'}
          color={nextBtnDisabled ? '#4D4D4D' : '#FFF'}
          disabled={nextBtnDisabled}
          onClick={() => {
            let d = {
              userNo: data.userNo,
              company: data.company,
              industry: data.industry,
              industryDetail: data.industryDetail,
              marketingTerm: data.marketingTerm,
              serviceTerm: data.serviceTerm,
              userName: data.userName,
              userPW: data.userPW,
              userPhone: data.userPhone,
              telecomNo: data.telecomNo,
            };

            updateUser(
              d,
              () => {},
              () => {
                alert('회원정보가 변경되었습니다.');
              },
              (v) => {
                console.log(v);
              },
              token
            );
          }}
        >
          저장
        </RoundButton>
      </ButtonContainer>
    </div>
  );
}
export default MyPageMemberInfo;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 30px 0 30px 0;
`;

const RoundButton = styled.div`
  display: flex;
  width: 100px;
  height: 40px;
  padding: 6px 6px;
  text-align: center;
  border-radius: 20px;
  font-size: 20px;
  border-width: 0;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
`;
